"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAttachmentFileType = void 0;
function validateAttachmentFileType(fileType, allowedTypeList) {
    return allowedTypeList.includes(fileType);
}
exports.validateAttachmentFileType = validateAttachmentFileType;
